import { Button, CircularProgress, Stack, TextField } from '@mui/material';
import React, { useCallback, useState } from 'react';
import { createInboxChat } from 'services/files';
import { useAsyncCallback } from 'hooks/useAsyncCallback';

type InboxFormProps = {
  fileId: number;
  reload?: () => Promise<void>;
};
export const InboxForm = ({ fileId, reload }: InboxFormProps) => {
  const [input, setInput] = useState('');
  const handleCreateMessage = useCallback(async () => {
    if (!input.trim()) return;
    if (!fileId) return;
    await createInboxChat(input, Number(fileId));
    reload && (await reload());
    setInput('');
  }, [fileId, input]);

  const { asyncCallback, loadingCb } = useAsyncCallback(handleCreateMessage, [], false);
  return (
    <Stack width={'100%'}>
      <Stack direction="row" spacing={1}>
        <TextField
          fullWidth
          size="small"
          placeholder="Enter note..."
          value={input}
          onChange={(e) => setInput(e.target.value)}
          onKeyDown={(e) => {
            if (e.key === 'Enter') asyncCallback();
          }}
        />
        <Button variant="contained" onClick={asyncCallback}>
          {loadingCb ? <CircularProgress size={20} style={{ color: '#fff' }} /> : 'Send'}
        </Button>
      </Stack>
    </Stack>
  );
};
